import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TrainingKnowledgeExchange.css";
import Footer from "../Home/Footer";
import RecentexposurevisitssectionImage1 from "../assets/img/Recentexposurevisitssection-1.jpg";
import RecentexposurevisitssectionImage2 from "../assets/img/Recentexposurevisitssection-2.jpg";
import RecentexposurevisitssectionImage3 from "../assets/img/Recentexposurevisitssection-3.jpg";
import RecentexposurevisitssectionImage4 from "../assets/img/Recentexposurevisitssection-4.jpg";
import RecentexposurevisitssectionImage5 from "../assets/img/Recentexposurevisitssection-5.jpg";

const exposureVisitsData = [
  {
    id: 1,
    image: RecentexposurevisitssectionImage1,
    title: "International Agriculture Tour",
    description:
      "Exploring advanced farming techniques in developed countries.",
    aos: "fade-right",
  },
  {
    id: 2,
    image: RecentexposurevisitssectionImage2,
    title: "Smart Farming Innovations",
    description:
      "Learning about AI, IoT, and automation in modern agriculture.",
    aos: "fade-up",
  },
  {
    id: 3,
    image: RecentexposurevisitssectionImage3,
    title: "Organic Farming Workshops",
    description:
      "Engaging with experts on sustainable and eco-friendly farming.",
    aos: "fade-left",
  },
  {
    id: 4,
    image: RecentexposurevisitssectionImage4,
    title: "Agro-Technology Fair",
    description: "Discovering new agricultural machinery and tools.",
    aos: "zoom-in",
  },
];

const feedbackData = [
  {
    id: 1,
    name: "John Doe",
    comment:
      "The exposure visit was a fantastic learning experience! Highly recommended.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHdLZAJzeEA2iYjsrN4CEXrg8ATQ1tB04blQ&s",
    aos: "flip-left",
  },
  {
    id: 2,
    name: "Emily Smith",
    comment:
      "I learned a lot about modern farming techniques. Great initiative!",
    image:
      "https://pbs.twimg.com/profile_images/1631145337728692229/JpV6AlUL_400x400.jpg",
    aos: "flip-up",
  },
  {
    id: 3,
    name: "Yashraj Thakur",
    comment:
      "Wonderful experience, met many experts, and gained valuable insights.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3tdr47XAZEi4ISV4Z5287UZE8A5M9N19Wbg&s",
    aos: "flip-right",
  },
];

const TrainingKnowledgeExchange = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    // <div className="exposure-visits-page">
    //   {/* Hero Section */}
    //   <section
    //     className="hero-section-exposure"
    //     style={{
    //       background: `url(${RecentexposurevisitssectionImage5}) no-repeat center center`,
    //       backgroundSize: "cover",
    //     }}
    //   >
    //     <div className="overlay"></div>
    //     <div className="hero-content">
    //       <h1 data-aos="fade-up" style={{ color: "#d4561a" }}>
    //         🌍 Exposure Visits
    //       </h1>
    //       <p data-aos="fade-up" data-aos-delay="200">
    //         Discover how Exposure Visits enhance learning, networking, and
    //         knowledge exchange for farmers and professionals.
    //       </p>
    //     </div>
    //   </section>

    //   {/* Auto-Sliding Visits Section */}
    //   <section className="visits-section container">
    //     <h2 className="section-title" data-aos="fade-up">
    //       Recent Exposure Visits
    //     </h2>
    //     <Slider {...settings} className="visits-slider">
    //       {exposureVisitsData.map((visit) => (
    //         <div key={visit.id} className="visit-card" data-aos={visit.aos}>
    //           <img src={visit.image} alt={visit.title} />
    //           <div className="visit-content">
    //             <h3>{visit.title}</h3>
    //             <p>{visit.description}</p>
    //             <a href="#" className="btn">
    //               Read More
    //             </a>
    //           </div>
    //         </div>
    //       ))}
    //     </Slider>
    //   </section>

    //   {/* Visitor Feedback Section */}
    //   {/* <section className="feedback-section" data-aos="fade-in">
    //     <h2
    //       className="section-title"
    //       data-aos="fade-up"
    //       style={{ color: "#d4561a" }}
    //     >
    //       Visitor Feedback
    //     </h2>
    //     <div className="feedback-container">
    //       {feedbackData.map((feedback) => (
    //         <div
    //           key={feedback.id}
    //           className="feedback-card"
    //           data-aos={feedback.aos}
    //         >
    //           <img
    //             src={feedback.image}
    //             alt={feedback.name}
    //             className="feedback-image"
    //           />
    //           <p className="feedback-text">"{feedback.comment}"</p>
    //           <h3 className="feedback-name" style={{ color: "#d4561a" }}>
    //             - {feedback.name}
    //           </h3>
    //         </div>
    //       ))}
    //     </div>
    //   </section> */}

    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingKnowledgeExchange;
